import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import "../../src/fonts/fonts.css";
import FullLogo from "images/appnigma_full_logo.webp";
import appnigmaIcon from "images/appnigma_logo_sm.webp";

export default function TopLayout(props) {


  return (
    <React.Fragment>
      <Helmet>
        <html lang="en" />
        <meta charset="utf-8" />
        <link rel="shortcut icon" href={appnigmaIcon} />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#ffffff" />
        <meta
          name="description"
          content="With Appnigma AI, you can build Salesforce apps quickly and easily—no coding required. Just a few clicks to create powerful apps and streamline your workflow!"
        />
        <meta name="robots" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={FullLogo} />
        <meta property="og:title" content="Appnigma AI: Generate Salesforce Apps in Minutes!" />
        <meta
          property="og:description"
          content="With Appnigma AI, you can build Salesforce apps quickly and easily—no coding required. Just a few clicks to create powerful apps and streamline your workflow!"
        />
        <meta property="og:url" content="https://appnigma.ai/" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />

        {/* Optimizing Images by preloading them */}
        <link rel="preload" href={FullLogo} as="image" />
        <link rel="preload" href={appnigmaIcon} as="image" />
        <title>Appnigma AI: Generate Salesforce Apps in Minutes!</title>
      </Helmet>
      {props.children}
    </React.Fragment>
  );
}

TopLayout.propTypes = {
  children: PropTypes.node,
};
